<template>
  <div class="hvh-flex h-100">
    <ActicsLandingPageLeftMenu v-model="$store.state.actics.menuOpened" />
    <div class="right-box grow-1" :class="{ opened: $store.state.actics.menuOpened }">
      <slot />
    </div>
  </div>
</template>
<script>
import ActicsLandingPageLeftMenu from './ActicsLandingPageLeftMenu.vue';
import '../../../assets/css/nexa-fonts.css';
export default {
  components: { ActicsLandingPageLeftMenu },
}
</script>

<style lang="scss" scoped>
.right-box {
  position: relative;
  margin-left: 44px;
  transition: 0.4s ease-in-out;

  &.opened {
    margin-left: 280px;
  }
}
</style>